<template>
    <span>{{ money }}</span>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            required: true,
        },
        locale: {
            type: String,
            required: false,
            default: 'de',
        }
    },
    computed: {
        money() {
            return this.$n(this.value, 'currency', this.locale);
        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">

</style>
